import { RootState } from '../../Store';
import { tokenExpired } from '../../Store/Auth/action';

import { useDispatch, useSelector } from 'react-redux';

export const isTokenValid = (): boolean => {
    const token = useSelector<RootState, string | undefined>(state => state.auth.token);
    return token !== undefined;
}

const useAuthentication = (): void => {
    const dispatch = useDispatch();

    if (!isTokenValid()) {
        dispatch(tokenExpired());
    }
};

export default useAuthentication;
